import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId, getuserId } from "../../utility/tokenUtility";


const fetchServiceOptions = async () => {
  const facilityId = getFacilityId('facilityId');
  const companyId = getcompanyId('companyId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityId}`,
      config
    );
    const serviceData = response.data.masservicedetails;

    const options = serviceData.map((service) => ({
      value: service.service,
      label: service.service,
      id: service.id,
    }));

    return options;
  } catch (error) {
    console.error("Error fetching service options:", error);
    return [];
  }
};
const fetchCalibrationCategoryOptions = async () => {

  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${MasterGraph}/api/masters/GetCalibarationCategoryList`, config);


    const licenseCategoryData = response.data || [];

    if (Array.isArray(licenseCategoryData)) {
      const categoryOptions = licenseCategoryData.flatMap((licenseCategory) => {
        const categories = licenseCategory.mascalibrationcertheaders || [];

        if (categories.length === 0) {
          return [
            {
              value: licenseCategory.categoryName,
              label: licenseCategory.categoryName,
              id: licenseCategory.maslicensetypeId,
              primaryId: licenseCategory.id
            },
          ];
        }

      });

      return categoryOptions;
    }

  } catch (error) {
    console.error("Error fetching calibration category options:", error);
    return [];
  }
};


const fetchcalibrationTypeCodeOptions = async (ServiceId, categoryid) => {
  const companyId = getcompanyId('companyId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(
      `${MasterGraph}/api/masters/GetLicenseDropdownList/${ServiceId}/${companyId}/${categoryid}`,
      config
    );

    const options = response.data.map((ltc) => ({
      value: ltc.licntypevalue,
      label: ltc.licntypecode,
      id: ltc.id,
    }));


    return options;
  } catch (error) {
    console.error("Error fetching calibration category:", error);
    return [];
  }
};


const fetchHospitalName = async () => {
  const companyId = getcompanyId('companyId');
  const userId = getuserId('UserId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}`, config);
    if (response.data && Array.isArray(response.data)) {
      const options = response.data.map((hn) => ({
        value: hn.facilityName,
        label: hn.facilityName,
        id: hn.id,
      }));
      return options;
    }
  } catch (error) {
    console.error("Error fetching Hospital Names:", error);
  }
};

const deleteLicensCertificateSubform = async (id) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const res = await axios.delete(`${MasterGraph}/api/mascalibrationcertdetails/${id}`, config);
    if (res.status === 204) {
    }
    await fetchSubformData();
  } catch (error) {
    console.error("Error deleting License Certificate:", error);
  }
};


const fetchSubformsave = async (detail) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const detailResponses = await axios.post(`${MasterGraph}/api/mascalibrationcertdetails`, detail, config);
  } catch (error) {
    console.error("Error saving subform:", error);
  }
};

const fetchSubformData = async (serviceType, HeaderFormid) => {

  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;

    const subformdata = await axios.get(`${checkGraph}/api/GraphCalibarationCertificate/GetCalibarationcerdetailsbems/${HeaderFormid}`, config);


    return subformdata;
  } catch (error) {
    return error;
  }
};

const fetchAssetNo = async (serviceType) => {
  const facilityId = getFacilityId("facilityId");
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;


    const response = await axios.get(`${checkGraph}/api/Predictivemaintenance/GetpredictivemaintenanceAssetNoFetch/${facilityId}?size=6000`, config
    );
    const assetnooptions = response?.data?.map((asset) => ({
      value: asset.assetdesc,
      label: `${asset.assetNo} - ${asset.assetdesc}`,
      assetDesc: asset.assetdesc,
      assetNo: asset.assetNo,
      assetNoDesc: {
        id: asset.assetId,
        label: asset.assetNo
      },
      id: asset.assetId,
    }));

    return assetnooptions;
  } catch (error) {
    console.error("Error fetching asset numbers:", error);
    return [];
  }
};


const fetchContactData = async () => {
  const companyId = getcompanyId('companyId')

  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?Size=100000`, config);
    const contactData = response.data;
    const contactoptions = contactData.map((con) => ({

      value: con.vendorname,
      label: `${con.vendorcode} - ${con.vendorname}`,
      id: con.id,
      contactno: con.vendorcode,
      contractdesc: con.vendorname,
      contractNoDesc: {
        id: con.id,
        label: con.vendorcode
      },
    }));
    return (contactoptions);
  } catch (error) {
    console.error("Error fetching Contact data:", error);
    return [];
  }
};


const fetchEmployeeData = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}`, config);
    const empdate = response.data;

    const employeeoptions = empdate.map((emp) => ({
      value: emp.employeename,
      label: `${emp.employeecode} - ${emp.employeename}`,
      employeedesc: emp.employeename,
      employeecode: emp.employeecode,
      id: emp.id,
      employeeNoDesc: {
        id: emp.id,
        label: emp.employeecode
      },
    }));
    return (employeeoptions);
  } catch (error) {
    console.error("Error fetching Employee data:", error);
    return [];
  }
};
;

const deleteCalibrateCertificate = async (id) => {

  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.delete(`${MasterGraph}/api/mascalibrationcertheaders/${id}`, config);
    return response;
  }
  catch (error) {
    return error;
  }
};
const calibrationCertificateList = async (serviceType, pageIndex, pageSize, filterModel, sortModel) => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${MasterGraph}/api/masters/GetCalibarationLists/${facilityId}/${serviceType}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`, config);

    return response;
  }
  catch (error) {
    console.log(error);
  }
};

const calibrationCertificateExport = async (serviceType, filterModel, sortModel) => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(`${MasterGraph}/api/masters/GetExportCalibarationCer/${facilityId}/${serviceType}?filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`, config);

    return response;
  }
  catch (error) {
    console.log(error);
  }
};

const createCalibrationDetails = async (payload) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(`${MasterGraph}/api/mascalibrationcertheaders`, payload, config);
    return response.data;
  }
  catch (error) {
    return error;
  }
};

const updateCalibrationDetails = async (headerId, payload) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(`${MasterGraph}/api/mascalibrationcertheaders/${headerId}`, payload, config);
    return response.data;
  }
  catch (error) {
    return error;
  }
};

const createOrUpdateSubForm = async (headerId, payload) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(`${MasterGraph}/api/mascalibrationcertdetails/${headerId}`, payload, config);
    return response.data;
  }
  catch (error) {
    return error;
  }
};

const getSubForm = async (serviceType, headerId) => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
    const checkApi = serviceType === "FEMS" ? 'api/GraphCalibarationCertificate/GetCalibarationcerdetailsfems' : 'api/GraphCalibarationCertificate/GetCalibarationcerdetailsbems'

    const response = await axios.get(`${checkGraph}/${checkApi}/${headerId}/${facilityId}`, config);
    return response.data;
  }
  catch (error) {
    return error;
  }
};

const deleteSubForm = async (headerId) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.delete(`${MasterGraph}/api/mascalibrationcertdetails/${headerId}`, config);
    return response.data;
  }
  catch (error) {
    return error;
  }
};


const CalibrationCertificateRepository = {

  fetchServiceOptions,
  fetchCalibrationCategoryOptions,
  fetchcalibrationTypeCodeOptions,
  deleteLicensCertificateSubform,
  fetchSubformData,
  fetchSubformsave,
  deleteCalibrateCertificate,
  calibrationCertificateList,
  calibrationCertificateExport,
  // fetchSaveform,
  fetchEmployeeData,
  fetchContactData,
  fetchAssetNo,
  fetchHospitalName,
  createCalibrationDetails,
  createOrUpdateSubForm,
  getSubForm,
  updateCalibrationDetails,
  deleteSubForm
};

export default CalibrationCertificateRepository;